module.exports = __webpack_public_path__ + "static/media/edit-unavailability.8f78bc60.png";